export interface PortalService {
  name: string;
  value: PortalServiceEnum;
}

export enum PortalServiceEnum {
  IBANFLEX = "ibanflex",
  KATBIT = "katbit",
  FASTPAY = "fastpay",
  BREADXPAY = "breadxpay",
  FINOVO = "finovo",
}

export interface EntityPortalService {
  name: string;
  value: PortalServiceEnum;
  is_attached: boolean;
  is_allowed: boolean;
}
